var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialInfrastructure = function SvgSocialInfrastructure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "social-infrastructure_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social-infrastructure_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37 10.873v6.618h13.247v-6.618H16.64V9.554h.66V8.236H12.67V6.917h2.65v-1.99h-2.65v-.66h-1.354v3.969H6.689v1.318h.66v1.32H5.37Zm9.95 1.33h1.295v1.32h-1.294v-1.32Zm0 2.638h1.295v1.319h-1.294V14.84Zm-2.649-2.637h1.295v1.319h-1.295v-1.32Zm0 2.637h1.295v1.319h-1.295V14.84Zm-2.637-2.637h1.295v1.319h-1.295v-1.32Zm0 2.637h1.295v1.319h-1.295V14.84Zm-2.65-2.637H8.68v1.319H7.385v-1.32Zm0 2.637H8.68v1.319H7.385V14.84Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social-infrastructure_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSocialInfrastructure as ReactComponent };